import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


/**
 * Local components & Services
 */
import { DisplayDashboardComponent } from './display-dashboard/display-dashboard.component';
import { DashboardService } from './services/dashboard.service';


/**
 * Share Eia Components
 */
import { EiaChartsModule} from '../share-modules/eia-charts/eia-charts.module';
//import { MyDateRangePickerModule } from 'mydaterangepicker';

//import { PdfSelectorComponent} from "../pdf-selector/pdf-selector.component";


@NgModule({
  imports: [
    CommonModule,
    EiaChartsModule
  ],
  providers: [
    DashboardService
  ],
  declarations: [DisplayDashboardComponent]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.module.ts